import React, { useEffect, useRef } from "react";
import { Niivue } from "@niivue/niivue";

// on importe *tout* le module pour capturer toutes les formes d’export
import * as dicomModule from "@niivue/dicom-loader";

const getDicomLoader = () => {
  // ▸ priorité : export nommé « dicomLoader »
  if (typeof dicomModule.dicomLoader === "function") return dicomModule.dicomLoader;
  // ▸ fallback : export default
  if (typeof dicomModule.default === "function")     return dicomModule.default;
  // ▸ dernier recours : le module lui‑même s’il est déjà une fonction
  if (typeof dicomModule === "function")             return dicomModule;
  throw new Error("dicomLoader export not found");
};

const NiivueViewer = ({ fileUrl, fileName }) => {
  const canvasRef = useRef(null);
  const nvRef     = useRef(null);

  useEffect(() => {
    if (!fileUrl) return;
    const nv = new Niivue({ backColor: [0, 0, 0, 0], dragMode: "contrast" });

    // ─── enregistre le loader DICOM ───────────────────────────
    const dicomLoader = getDicomLoader();   // ← toujours une fonction
    nv.useDicomLoader(dicomLoader);
    // ─────────────────────────────────────────────────────────

    nv.attachToCanvas(canvasRef.current);
    nvRef.current = nv;

    const isDicom = /\.dcm$/i.test(fileName);

    // Charge le fichier selon son extension
    const loadPromise = isDicom
      ? nv.loadDicoms([{ url: fileUrl, name: fileName }])
      : nv.loadVolumes([{ url: fileUrl, name: fileName, colormap: "gray" }]);

    loadPromise
      .then(() => {
        nv.setSliceType(nv.sliceTypeMultiplanar);
        nv.drawScene();
      })

    // wheel → scroll lorsqu’on n’est pas en zoom Ctrl+Wheel
    const relayWheel = (e) => {
      if (!e.ctrlKey) {
        e.preventDefault();
        window.scrollBy({ top: e.deltaY });
      }
    };
    canvasRef.current.addEventListener("wheel", relayWheel, {
      passive: false,
      capture: true,
    });

    return () => {
      canvasRef.current.removeEventListener("wheel", relayWheel);
      nvRef.current?.dispose?.();
      nvRef.current = null;
    };
  }, [fileUrl, fileName]);

  return (
    <canvas
      ref={canvasRef}
      className="w-full h-60 max-h-60 rounded-lg overflow-hidden"
    />
  );
};

export default NiivueViewer;
